import Slugify from 'slugify';

export const slugify = (string: string) => Slugify(string, { lower: true });
